import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ProfessionalMapReviewsStaff() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  const [notes, setNotes] = useState({});
  const refresh = useCallback(async () => {
    setError("");
    try {
      const { data } = await api.get("/professional-map/reviews/staff/queue");
      setItems(Array.isArray(data) ? data : []);
    } catch (e) { setError(formatApiError(e)); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  async function moderate(item, decision, reply = false) {
    if (busy) return;
    setBusy(item.id); setError("");
    try {
      await api.post("/professional-map/reviews/staff/" + encodeURIComponent(item.id)
        + (reply ? "/reply-review" : "/moderate"), { decision, note: notes[item.id] || "" });
      await refresh();
    } catch (e) { setError(formatApiError(e)); }
    finally { setBusy(""); }
  }
  return <main className="mx-auto min-h-screen max-w-[980px] px-5 py-10 text-[#3A2B22]" data-testid="pm-review-staff">
    <Link to="/professional-map" className="text-sm underline underline-offset-4">К Профессиональной карте</Link>
    <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="font-serif text-3xl">Модерация отзывов</h1>
      <button type="button" onClick={refresh} className="min-h-11 rounded-xl border px-4">Обновить</button>
    </div>
    {error && <p role="alert" className="mt-4 text-sm">{error}</p>}
    {!items.length && !error && <p className="mt-4">Новых обращений на проверку нет.</p>}
    <div className="mt-6 space-y-4">
      {items.map((item) => <article key={item.id} className="rounded-2xl border border-[#826751]/20 bg-white p-5">
        <p className="text-xs text-[#755F4E]">Профессиональная страница: {item.card_id} · Статус: {item.state}</p>
        <p className="mt-2 font-medium">{item.author_name}</p>
        <p className="mt-2 whitespace-pre-wrap break-words text-sm">{item.text}</p>
        {(item.reports || []).map((report, i) => <p key={i} className="mt-2 rounded-lg bg-[#FCF1E8] p-3 text-sm">
          Жалоба: {report.reason} {report.details && " · " + report.details}
        </p>)}
        {item.owner_reply && <p className="mt-3 whitespace-pre-wrap rounded-lg bg-[#F8F2E9] p-3 text-sm">
          Ответ владельца: {item.owner_reply} {item.reply_state === "pending" && "(ожидает проверки)"}
        </p>}
        <label className="mt-3 block text-xs">Комментарий модерации
          <textarea value={notes[item.id] || ""} onChange={(e) => setNotes(p => ({ ...p, [item.id]: e.target.value }))}
            maxLength={500} rows={2} className="mt-1 w-full rounded-lg border p-2 text-sm"/>
        </label>
        <div className="mt-3 flex flex-wrap gap-2">
          {["pending", "hidden"].includes(item.state) && <button disabled={!!busy} onClick={() => moderate(item, "publish")}
            className="min-h-11 rounded-xl border px-3 text-sm">Опубликовать</button>}
          {["pending", "published"].includes(item.state) && <>
            <button disabled={!!busy} onClick={() => moderate(item, "hide")}
              className="min-h-11 rounded-xl border px-3 text-sm">Скрыть</button>
            <button disabled={!!busy} onClick={() => moderate(item, "reject")}
              className="min-h-11 rounded-xl border px-3 text-sm">Отклонить</button>
          </>}
          {!!item.reports?.length && <button disabled={!!busy} onClick={() => moderate(item, "dismiss")}
            className="min-h-11 rounded-xl border px-3 text-sm">Отклонить жалобу</button>}
          {item.reply_state === "pending" && <>
            <button disabled={!!busy} onClick={() => moderate(item, "publish", true)}
              className="min-h-11 rounded-xl border px-3 text-sm">Разрешить ответ</button>
            <button disabled={!!busy} onClick={() => moderate(item, "hide", true)}
              className="min-h-11 rounded-xl border px-3 text-sm">Скрыть ответ</button>
          </>}
        </div>
      </article>)}
    </div>
  </main>;
}
